import { useEffect } from 'react';

/** Marks the "En esta página" chip of the section being read (links inside [data-toc]). */
export function useTocHighlight(): void {
  useEffect(() => {
    const links = Array.from(document.querySelectorAll<HTMLAnchorElement>('[data-toc] a'));
    if (!links.length || !('IntersectionObserver' in window)) return undefined;

    const byId = new Map(links.map((a) => [a.getAttribute('href')!.slice(1), a]));
    let current: HTMLAnchorElement | null = null;

    const spy = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const link = byId.get(entry.target.id);
          if (!link || link === current) return;
          current?.classList.remove('is-current');
          current?.removeAttribute('aria-current');
          link.classList.add('is-current');
          link.setAttribute('aria-current', 'true');
          current = link;
        });
      },
      { rootMargin: '-20% 0px -70% 0px' },
    );
    byId.forEach((_, id) => {
      const el = document.getElementById(id);
      if (el) spy.observe(el);
    });
    return () => spy.disconnect();
  }, []);
}
